/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReportExistsRequest } from '../../models/construction-day-report-exists-request';
import { WorkingEntry } from '../../models/working-entry';

export interface ApiV0ConstructiondayreportExistingReportInfosPost$Json$Params {
      body?: ConstructionDayReportExistsRequest
}

export function apiV0ConstructiondayreportExistingReportInfosPost$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportExistingReportInfosPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkingEntry>>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportExistingReportInfosPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkingEntry>>;
    })
  );
}

apiV0ConstructiondayreportExistingReportInfosPost$Json.PATH = '/api/v0/constructiondayreport/existingReportInfos';
